import { ISaleData } from 'types/orders';
import ToolOrderEdition from '../ToolOrderEdition/ToolOrderEdition';
import { IpillsByReference } from 'types/orders';

import './ToolEditionCard.scss';

interface IToolEditionCardProps {
  productName: string;
  salesInGroup: Array<{ sale: ISaleData; index: number }>;
}

/**
 * Componente que muestra un grupo de equipos de la misma marca/descripción
 * Renderiza la información del producto una vez y luego cada serial con su precio
 */
const ToolEditionCard = ({ productName, salesInGroup }: IToolEditionCardProps) => {
  const firstSale = salesInGroup[0]?.sale;

  const pills =
    typeof firstSale?.products?.pills === 'string'
      ? (JSON.parse(firstSale.products?.pills || '{}') as IpillsByReference)
      : firstSale?.products?.pills;

  return (
    <section className="toolEditionCard">
      <div className="toolInfo">
        <div className="toolHeader">
          <div className="toolDetailsContainer">
            <p className="toolNameWithPills">
              <span className="toolName">{productName}</span>
              {pills &&
                Object.values(pills).map(
                  (pill: string | null, index: number) =>
                    pill && (
                      <span key={`${pill}-${index}`} className="pill">
                        {pill}
                      </span>
                    )
                )}{' '}
            </p>
            <p className="toolSku">
              <span className="toolSkuLabel">SKU: </span>
              <span className="toolSkuValue">{firstSale?.products?.sku}</span>
            </p>
          </div>
          <div className="toolCountContainer">
            <span className="toolCountLabel">
              {(salesInGroup?.length ?? 0) > 1 ? `${salesInGroup?.length} seriales` : '1 serial'}
            </span>
          </div>
        </div>
        {salesInGroup?.map(({ sale, index }) => (
          <ToolOrderEdition
            key={sale.id || `${sale.products?.sku}-${index}`}
            serial={sale.products?.serial || ''}
            saleIndex={index}
          />
        ))}
      </div>
    </section>
  );
};

export default ToolEditionCard;
